<template>
  <div class="textarea">
    <textarea
      :placeholder="label"
      @input="$emit('inputchange', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style></style>
